import { PureComponent, Fragment, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { withTranslation } from 'react-i18next';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import moment from 'moment';

import {
  Container,
  Grid,
  Segment,
  Button,
  Dimmer,
  Modal,
  Loader,
  Icon,
} from 'semantic-ui-react';

import {
  CustomSegment,
  SurveyReview,
  EmptyContainer,
  SuccessContainer,
} from '../../components';

import { ageOptions } from '../../utils/constant';
import { decodeBase64String } from '../../utils';
import { UserTextService } from '../../services';
import i18n from '../../utils/i18n';
import { getSurvey, postSurvey } from '../../store/actions';
import { PostalCodeSearchInput } from '../../components/postalCodeSearchInput';

import {
  isArray,
  isEmpty,
  find,
  map,
  isNumber,
  orderBy,
} from '../../utils/lodash';

import loginLogo from '../../assets/whitebox-login-logo.svg';
import { INSTANCE_APP_URL } from '../../utils/instanceConstant';

import './survey.scss';

function QuestionComponent({ id, type, label, t }) {
  let component = null;
  const [postalCode, setPostalCode] = useState(null);

  const renderAgeOptions = () => {
    return map(ageOptions, (ageOption, i) => {
      return <option value={ageOption}>{ageOption}</option>;
    });
  };

  const changePostalCode = ({ target }) => {
    if (isNumber(parseInt(target.value))) {
      setPostalCode(target.value);
    }
  };

  switch (type) {
    case 'FREE':
      component = (
        <AvField
          name={`customQuestion_${id}`}
          style={{ minHeight: '6.25rem' }}
          type="textarea"
          label={label ? label : t('survey.defaultQuestionLabel')}
        />
      );
      break;
    case 'AGE':
      component = (
        <Fragment>
          <AvField
            label={t('survey.ageQuestionLabel')}
            name={`customQuestion_${id}`}
            type="select"
            className="org-inputs"
          >
            <option value="" disabled defaultValue>
              {t('survey.selectAgePlaceholder')}
            </option>
            {renderAgeOptions()}
          </AvField>
          <small className="form-text text-muted">
            {t('survey.ageClassificationHelp')}
          </small>
        </Fragment>
      );
      break;
    case 'EMAIL':
      component = (
        <AvField
          name={`customQuestion_${id}`}
          type="email"
          className="org-inputs"
          label={label ? label : t('survey.emailQuestionLabel')}
          validate={{
            maxLength: {
              value: 200,
              errorMessage: t('survey.maxCharactersError'),
            },
            email: {
              value: true,
              errorMessage: t('survey.validEmailError'),
            },
          }}
        />
      );
      break;
    case 'POSTCODE':
      component = (
        <div className="hidden-postcode">
          <PostalCodeSearchInput
            value={postalCode}
            onChange={changePostalCode}
            getLocation={(data) => setPostalCode(data.postcode)}
          />
          <AvField
            name={`customQuestion_${id}`}
            type="hidden"
            className="hidden-component"
            value={postalCode}
          />
        </div>
      );
      break;

    default:
      break;
  }

  return (
    component && (
      <Grid.Row>
        <Grid.Column computer={12}>{component}</Grid.Column>
      </Grid.Row>
    )
  );
}

class Surveys extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      surveyId: null,
      evaluations: [],
      results: [],
      surveySubmitted: false,
      ipLock: false,
      preview: false,
      lang: null,
    };
    this.updateResults = this.updateResults.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  async getSetSurveyData() {
    this.setState({ surveyId: this.props.match.params.surveyId });
    await this.props.getSurvey(
      NotificationManager,
      this.props.match.params.surveyId
    );

    let { surveyData } = this.props;
    if (isEmpty(surveyData)) return;

    let evaluations = [];
    let results = [];

    for (const val of surveyData.evaluation) {
      const altLanguages = {};
      console.dir(val.altLanguages);
      for (const lang in val.altLanguages || {}) {
        const values = val.altLanguages[lang];
        altLanguages[lang] = {
          heading: values.heading
            ? UserTextService.removeEditableText(values.heading)
            : '',
          methodHeading: values.methodHeading
            ? UserTextService.removeEditableText(values.methodHeading)
            : '',
          question1: values.question1
            ? UserTextService.removeEditableText(values.question1)
            : '',
          question2: values.question2
            ? UserTextService.removeEditableText(values.question2)
            : '',
        };
      }

      evaluations.push({
        question: {
          heading: val.heading
            ? UserTextService.removeEditableText(val.heading)
            : '',
          methodHeading: val.methodHeading
            ? UserTextService.removeEditableText(val.methodHeading)
            : '',
          question1: val.question1
            ? UserTextService.removeEditableText(val.question1)
            : '',
          question2: val.question2
            ? UserTextService.removeEditableText(val.question2)
            : '',
          altLanguages,
        },
        objectiveId: val.objectiveId,
        outcome: val.outcome,
        method: val.method,
        cumulative: val.cumulative,
      });

      results.push({
        id: val.objectiveId,
        result1: 1,
        result2: Boolean(val.cumulative) ? 1 : 0,
      });
    }

    console.warn('EVALUATIONS');
    console.dir(evaluations);

    this.setState({
      results,
      evaluations,
      preview: this.props.match.path === '/preview-survey/:surveyId',
      lang: surveyData?.supportedLanguages?.[0] || null,
    });
  }

  async componentDidMount() {
    await this.getSetSurveyData();
  }

  async componentDidUpdate(nextProps) {
    if (nextProps !== this.props) {
      // await this.getSetSurveyData ();
    }
  }

  updateResults(data) {
    let { results } = this.state;
    results.map((val) => {
      if (val.id === data.id) {
        return data;
      }
      return val;
    });
    this.setState({ results }, () => {});
  }

  renderQuestions() {
    let { evaluations = [], results, lang } = this.state;
    evaluations = orderBy(evaluations, (i) => i.objectiveId);
    return evaluations.map((evaluation, i) => {
      let result = find(results, { id: evaluation.objectiveId });
      return (
        <Segment key={i} stacked className="my-3">
          <SurveyReview
            index={i}
            updateResults={this.updateResults}
            ratingData={result}
            {...evaluation}
            lang={lang}
          />{' '}
        </Segment>
      );
    });
  }

  handleValidSubmit = async (event, values) => {
    try {
      let { results } = this.state;
      results.map((val) => {
        val.reason = values[`${val.id}_Reason`] || '';
        val.email = values[`${val.id}_Email`] || '';
        val.postcode = values[`${val.id}_Postcode`] || '';
        val.comment = values[`${val.id}_Comment`] || '';
        return val;
      });

      const customAnswers = [];
      for (const key in values) {
        if (values.hasOwnProperty(key)) {
          if (key.indexOf('customQuestion_') >= 0) {
            const question = key.split('_');
            if (question[0] === 'customQuestion') {
              const answer = values[key];
              if (answer !== '') {
                customAnswers.push({
                  id: Number(question[1]),
                  answer,
                });
              }
            }
          }
        }
      }

      let data = {
        customAnswers,
        results,
        email: values.email,
        evalPlanId: this.props.surveyData.evalPlanId,
      };
      const { ipLock } = await decodeBase64String(this.state.surveyId);

      await this.props.postSurvey(
        NotificationManager,
        data,
        this.props.match.params.surveyId
      );
      this.setState({ surveySubmitted: true, ipLock });
    } catch (error) {}
  };

  redirectToWebsite() {
    window.location.href = INSTANCE_APP_URL;
  }

  redirectToNextSurvey(projectId) {
    // TODO:hardcode
    // OMG TRIPLE YUCK!!!!
    if (projectId === 1879) {
      window.location.href =
        'https://www.basscoast.vic.gov.au/robertsmithsurvey';
    } else {
      window.location.href = '';
    }
  }

  async toggleLang(lang) {
    await this.setState({ lang });
  }

  renderSurveyBrandHeader() {
    const { t, surveyData } = this.props;
    const organisation = surveyData?.organisationId || {};
    const companyLogoUrl = organisation?.logo?.documentUrl;
    const organisationName = organisation?.name || '';

    return (
      <Grid.Row className="survey-sub-header">
        <div className="survey-company-brand">
          {companyLogoUrl ? (
            <img
              alt={`${organisationName} logo`}
              className="survey-company-logo"
              src={companyLogoUrl}
            />
          ) : organisationName ? (
            <div className="survey-company-name">{organisationName}</div>
          ) : null}
        </div>
        <Link className="survey-generated-by" to={'/'}>
          <span className="survey-generated-by-text">
            {t('survey.generated_by')}
          </span>
          <img alt="TaksoLogo" className="survey-takso-logo" src={loginLogo} />
        </Link>
      </Grid.Row>
    );
  }

  render() {
    const { ipLock, modal, preview, lang } = this.state;
    const {
      surveyData,
      surveyGetLoading = false,
      errorMessage,
      t,
    } = this.props;
    const surveyValidation = moment(surveyData.eventStartDate) > moment();
    const supportedLanguages = isArray(surveyData.supportedLanguages)
      ? surveyData.supportedLanguages
      : [];
    const i18nParams = lang ? { lng: lang } : {};

    return (
      <div className="full-width">
        <Container fluid className="survey-header">
          {surveyGetLoading ? (
            <Segment className="loaderSegment">
              <Dimmer active>
                <Loader />
              </Dimmer>
            </Segment>
          ) : (
            <>
              {this.renderSurveyBrandHeader()}
              <div className="mainRow">
                {this.state.surveySubmitted ? (
                  <Segment className="notFoundSegment" textAlign="center">
                    <Grid>
                      <Grid.Row>
                        <SuccessContainer
                          success
                          surveyData={surveyData}
                          lang={lang}
                        />
                      </Grid.Row>
                      {!ipLock ? (
                        <Grid.Row className="survey-center">
                          <div className="display-flex mt-24">
                            {/* WTF IS THIS HARDCODED PROJECT ID 1879??? YUCK YUCK YUCK */}
                            {/* eslint-disable-next-line */}
                            {surveyData.projectId === 1879 ? null : (
                              <Modal
                                open={modal}
                                onOpen={() => this.toggle()}
                                onClose={() => this.toggle()}
                                size="mini"
                                trigger={
                                  <Button className="Secondary-Button">
                                    {t('actions.close')}
                                  </Button>
                                }
                                className="close-confirmation-modal"
                              >
                                <Modal.Header>
                                  {t('survey.closeConfirmationTitle')}
                                </Modal.Header>
                                <Modal.Content>
                                  <p>{t('survey.closeConfirmationMessage')}</p>
                                </Modal.Content>
                                <Modal.Actions className="model-buttons">
                                  <Button
                                    className="Secondary-Button"
                                    onClick={() => this.toggle()}
                                  >
                                    {t('actions.no')}
                                  </Button>
                                  <Button
                                    className="Primary-Button"
                                    onClick={() => this.redirectToWebsite()}
                                  >
                                    {t('actions.yes')}
                                  </Button>
                                </Modal.Actions>
                              </Modal>
                            )}
                            {/* eslint-disable-next-line */}
                            <button
                              onClick={() =>
                                this.redirectToNextSurvey(surveyData.projectId)
                              }
                              className="Primary-Button"
                            >
                              {t('survey.nextResponseButton')}
                            </button>
                          </div>
                        </Grid.Row>
                      ) : null}
                    </Grid>
                  </Segment>
                ) : !isEmpty(surveyData) ? (
                  <CustomSegment
                    title={
                      surveyData.surveyTitle || surveyData.name
                        ? `${t('survey.surveyForPrefix')}${surveyData.surveyTitle || surveyData.name}`
                        : ''
                    }
                    children={
                      <Segment>
                        {supportedLanguages.length > 1 && (
                          <>
                            <div className="checkbox-container auto-width lang-picker">
                              <div className="label">
                                {t('common.language')}
                              </div>
                              <div className="button-include">
                                <Button.Group className="btn">
                                  {supportedLanguages.map((thisLang, idx) => (
                                    <Button
                                      active={thisLang === lang}
                                      onClick={() => this.toggleLang(thisLang)}
                                      key={idx}
                                    >
                                      {i18n.LANG_CODE_LABELS[thisLang]}
                                    </Button>
                                  ))}
                                </Button.Group>
                              </div>
                            </div>
                          </>
                        )}

                        <AvForm
                          onValidSubmit={this.handleValidSubmit}
                          className="survey-form"
                        >
                          {/****
                            <Grid columns={2} stackable>
                              <Grid.Column>
                                <AvField
                                  label="EMAIL"
                                  className="profile-inputs"
                                  name="email"
                                  type="email"
                                  placeholder="johndoe@whitebox.com"
                                />
                              </Grid.Column>
                            </Grid>

                            <div className="statement">
                              PRIVACY STATEMENT: As this is an online survey, we
                              require a unique identifier to ensure the response is
                              from a single source, in order to count this as a unique
                              response can you please provide your email address and
                              note the privacy policy. The email is encrypted and
                              stored and only used as a unique identifier to the
                              response. This information is not shared with any party
                              or used by the system for communication.
                            </div>
                          ****/}

                          <div
                            style={{
                              fontSize: '1.125rem',
                              lineHeight: '1.25rem',
                            }}
                          >
                            <Segment.Group>
                              {this.renderQuestions()}
                              <Fragment>
                                {!isEmpty(surveyData.customQuestions) ? (
                                  <Segment stacked>
                                    {/* "survey-gap" is what actually gives the standard
                                        questions' equivalent block (surveyReview.js's
                                        "Can you tell us why...") its left indent, via a
                                        .survey-for-test-type .survey-gap rule in
                                        activity.scss — it was missing here, which is why
                                        these fields sat flush left of the others. */}
                                    <Grid className="custom-gen-questions survey-gap">
                                      {map(
                                        surveyData.customQuestions,
                                        (question, i) => {
                                          return (
                                            <QuestionComponent
                                              key={i}
                                              type={question.type}
                                              label={question.label}
                                              id={question.id}
                                              t={t}
                                            />
                                          );
                                        }
                                      )}
                                    </Grid>
                                  </Segment>
                                ) : null}
                              </Fragment>
                            </Segment.Group>

                            {surveyValidation && (
                              <div className="info-box no-submissions">
                                <p>
                                  <Icon name="info circle" />{' '}
                                  {t('survey.notCollectingResponsesMessage')}
                                </p>
                              </div>
                            )}

                            {preview ? null : (
                              <Button
                                disabled={
                                  this.props.surveyPostLoading ||
                                  surveyValidation
                                }
                                loading={this.props.surveyPostLoading}
                                type="submit"
                                className="Primary-Button mt-24"
                              >
                                {t('actions.submit', i18nParams)}
                              </Button>
                            )}
                          </div>
                        </AvForm>
                      </Segment>
                    }
                    className="survey-for-test-type"
                  />
                ) : (
                  <Segment
                    className="notFoundSegment"
                    textAlign="center"
                    loading={this.props.surveyGetLoading}
                  >
                    {/* <div style={{color:'red',fontWeight:'bold',fontSize:'1.125rem'}}>Oops! Looks like the link you clicked is broken or expired</div> */}
                    <Grid>
                      <Grid.Row>
                        <EmptyContainer
                          msg={
                            errorMessage
                              ? errorMessage
                              : t('survey.brokenLinkMessage')
                          }
                        />
                      </Grid.Row>
                    </Grid>
                  </Segment>
                )}
              </div>
            </>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { survey } = state;
  return {
    surveyData: survey.surveyData,
    surveyGetLoading: survey.surveyGetLoading,
    surveyPostLoading: survey.surveyPostLoading,
    errorMessage: survey.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSurvey,
      postSurvey,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Surveys));
